__turbopack_context__.v({
  "arrowIcon": "CTASection-module__yxcNFW__arrowIcon",
  "arrowSlide": "CTASection-module__yxcNFW__arrowSlide",
  "buttonContainer": "CTASection-module__yxcNFW__buttonContainer",
  "buttonShimmer": "CTASection-module__yxcNFW__buttonShimmer",
  "ctaVisualContainer": "CTASection-module__yxcNFW__ctaVisualContainer",
  "float": "CTASection-module__yxcNFW__float",
  "flowVisualizationContainer": "CTASection-module__yxcNFW__flowVisualizationContainer",
  "gradientShift": "CTASection-module__yxcNFW__gradientShift",
  "gradientText": "CTASection-module__yxcNFW__gradientText",
  "liveDot": "CTASection-module__yxcNFW__liveDot",
  "livePerformance": "CTASection-module__yxcNFW__livePerformance",
  "mainContainer": "CTASection-module__yxcNFW__mainContainer",
  "numberCounter": "CTASection-module__yxcNFW__numberCounter",
  "particleFloat": "CTASection-module__yxcNFW__particleFloat",
  "partnerBadge": "CTASection-module__yxcNFW__partnerBadge",
  "performanceDot": "CTASection-module__yxcNFW__performanceDot",
  "pulse": "CTASection-module__yxcNFW__pulse",
  "pulsingDot": "CTASection-module__yxcNFW__pulsingDot",
  "pulsingIndicator": "CTASection-module__yxcNFW__pulsingIndicator",
  "rocketPulse": "CTASection-module__yxcNFW__rocketPulse",
  "shimmer": "CTASection-module__yxcNFW__shimmer",
  "statCard": "CTASection-module__yxcNFW__statCard",
  "statCardHover": "CTASection-module__yxcNFW__statCardHover",
  "statIndicator": "CTASection-module__yxcNFW__statIndicator",
  "statLabel": "CTASection-module__yxcNFW__statLabel",
  "statValue": "CTASection-module__yxcNFW__statValue",
  "textGlow": "CTASection-module__yxcNFW__textGlow",
  "trailFade": "CTASection-module__yxcNFW__trailFade",
  "trendingUp": "CTASection-module__yxcNFW__trendingUp",
  "usersIcon": "CTASection-module__yxcNFW__usersIcon",
  "wave": "CTASection-module__yxcNFW__wave",
  "waveBackground": "CTASection-module__yxcNFW__waveBackground",
});
